import { useMemo } from 'react';
import { useTriggerSelector } from './useTriggerSelector';

export const useExitIntentAreasSelector = () => {
  const trigger = useTriggerSelector();
  return useMemo(() => trigger.exitIntentAreas, [trigger.exitIntentAreas]);
};
